import React from "react";
import classnames from "@utils/classnames";

import Container from "@components/container";
import styles from "./index.module.scss";

const text = arr => {
  return (
    <div>
      {arr.map(word => (
        <div key={word}>{word}</div>
      ))}
    </div>
  );
};

const Section = ({
  title,
  children,
  className,
  headerWithContainer,
  ...props
}) => {
  const header = (
    <h3>
      {text(title[0])}
      {text(title[1])}
    </h3>
  );
  return (
    <div {...props} className={classnames(styles.section, className)}>
      {headerWithContainer ? (
        <Container className={styles.headerContainer}>{header}</Container>
      ) : (
        header
      )}
      <div>{children}</div>
    </div>
  );
};

export default Section;
